// extracted by mini-css-extract-plugin
export default {"element":"TimeSeriesContent_element__k5o17","close":"TimeSeriesContent_close__KQ2Hc"};